import CategoryView from "@/pages/category/components/CategoryView";

export default function TvCategory() {
  return <CategoryView type="tv" />;
}